import React from 'react';
import {bool, func, object, string} from 'prop-types';

import {connect} from 'react-redux';

import EsmsDialog from '../../components/EsmsDialog';

import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as ServiceManagementActions from '../../actions/serviceManagementActions';
import * as UiActions from '../../actions/uiActions';

import classes from './DeleteServiceCallModal.module.css';

const DeleteServiceCallModal = ({
    activeItem,
    clearErrors,
    close,
    deleteServiceCall,
    errors,
    isLoading,
    open,
    title,
    toggleLoading,
    ...props
}) => {
    const handleDelete = async () => {
        if (!isLoading) {
            toggleLoading(true);
            await deleteServiceCall(activeItem.id);
        }

        handleClose();
    };

    const handleClose = () => {
        clearErrors();
        toggleLoading(false);
        close();
    };

    return (
        <EsmsDialog
            confirmText="Delete"
            errors={errors}
            isLoading={isLoading}
            open={open}
            onClose={handleClose}
            onConfirm={handleDelete}
            title={title}
        >
            <div className={classes.DeleteServiceCallModal}>
                <p>Are you sure you want to delete {`WO-${activeItem.workOrder}`}?</p>
            </div>
        </EsmsDialog>
    );
};

DeleteServiceCallModal.defaultProps = {
    activeItem: {},
    close:      () => {},
    isLoading:  false,
    open:       false,
    title:      ''
};

DeleteServiceCallModal.propTypes = {
    activeItem: object,
    close:      func,
    isLoading:  bool,
    open:       bool,
    title:      string
};

const mapStateToProps = state => {
    return {
        activeItem: state.svcManagement.activeItem,
        errors:     state.messages.errors,
        isLoading:  state.ui.isLoading
    };
};

const mapDispatchToProps = {
    ...ApplicationMessageActions,
    ...ServiceManagementActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteServiceCallModal);
